<template>
  <div>
    <el-card>
      <div style="margin-bottom: 15px">
        <el-button type="primary" @click="handleAdd">新增规则</el-button>
        <el-select v-model="query.postType" clearable placeholder="全部帖子类型" style="width: 150px; margin-left: 12px" @change="fetchList">
          <el-option label="技能帖" value="SUPPLY"></el-option>
          <el-option label="需求帖" value="DEMAND"></el-option>
        </el-select>
      </div>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="ruleName" label="规则名称" min-width="160"></el-table-column>
        <el-table-column label="帖子类型" width="110">
          <template slot-scope="{ row }">{{ postTypeText(row.postType) }}</template>
        </el-table-column>
        <el-table-column prop="durationDays" label="时效(天)" width="100">
          <template slot-scope="{ row }">
            {{ row.durationDays }} 天
          </template>
        </el-table-column>
        <el-table-column label="费用(元)" width="110">
          <template slot-scope="{ row }">{{ formatAmount(row.priceAmount) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 'ENABLED' ? 'success' : 'info'" size="small">
              {{ row.status === 'ENABLED' ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="priority" label="排序" width="90"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.page"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.page = val; fetchList() }"
      ></el-pagination>
    </el-card>

    <el-dialog :title="isEdit ? '编辑时效规则' : '新增时效规则'" :visible.sync="dialogVisible" width="520px">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input v-model="form.ruleName" placeholder="例如：30天发帖"></el-input>
        </el-form-item>
        <el-form-item label="帖子类型" prop="postType">
          <el-select v-model="form.postType" placeholder="请选择" style="width: 100%">
            <el-option label="技能帖" value="SUPPLY"></el-option>
            <el-option label="需求帖" value="DEMAND"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发帖时效" prop="durationDays">
          <el-input-number v-model="form.durationDays" :min="1" :precision="0" :step="1" controls-position="right"></el-input-number>
          <span style="margin-left: 8px; color: #909399">天</span>
        </el-form-item>
        <el-form-item label="费用(元)" prop="priceAmountYuan">
          <el-input-number v-model="form.priceAmountYuan" :min="0" :precision="2" :step="1" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" style="width: 100%">
            <el-option label="启用" value="ENABLED"></el-option>
            <el-option label="停用" value="DISABLED"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="priority">
          <el-input-number v-model="form.priority" :min="0" :step="1" controls-position="right"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getFeeRules, addFeeRule, updateFeeRule, deleteFeeRule } from '../../api'

export default {
  name: 'FeeRuleManage',
  data() {
    return {
      query: { page: 1, pageSize: 10, postType: '' },
      list: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      isEdit: false,
      form: {
        id: null,
        ruleName: '',
        postType: 'SUPPLY',
        durationDays: 3,
        priceAmountYuan: 0,
        status: 'ENABLED',
        priority: 0
      },
      rules: {
        ruleName: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        postType: [{ required: true, message: '请选择帖子类型', trigger: 'change' }],
        durationDays: [{ required: true, type: 'number', min: 1, message: '请输入大于 0 的整数天数', trigger: 'change' }],
        priceAmountYuan: [{ required: true, message: '请输入费用', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    formatAmount(priceAmount) {
      const value = Number(priceAmount || 0) / 100
      return `¥${value.toFixed(2)}`
    },
    postTypeText(postType) {
      return postType === 'DEMAND' ? '需求帖' : '技能帖'
    },
    fetchList() {
      this.loading = true
      getFeeRules(this.query).then(res => {
        const data = res.data || {}
        this.list = data.records || data || []
        this.total = data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleAdd() {
      this.isEdit = false
      this.form = {
        id: null,
        ruleName: '',
        postType: 'SUPPLY',
        durationDays: 3,
        priceAmountYuan: 0,
        status: 'ENABLED',
        priority: 0
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.form = {
        id: row.id,
        ruleName: row.ruleName || '',
        postType: row.postType || 'SUPPLY',
        durationDays: row.durationDays || 3,
        priceAmountYuan: (row.priceAmount || 0) / 100,
        status: row.status || 'ENABLED',
        priority: row.priority || 0
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const data = {
          ruleName: this.form.ruleName,
          postType: this.form.postType,
          durationDays: this.form.durationDays,
          priceAmount: Math.round(Number(this.form.priceAmountYuan || 0) * 100),
          status: this.form.status,
          priority: this.form.priority
        }
        const request = this.isEdit ? updateFeeRule(this.form.id, data) : addFeeRule(data)
        request.then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.query.postType = this.form.postType
          this.query.page = 1
          this.fetchList()
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该规则吗？', '提示', { type: 'warning' }).then(() => {
        deleteFeeRule(row.id).then(() => {
          this.$message.success('已删除')
          this.fetchList()
        })
      }).catch(() => {})
    }
  }
}
</script>
